/** DOM id for the Suggested Legs header so pagination/search can scroll to cards, not the filter chip cloud. */
export const SUGGESTED_LEGS_ANCHOR_ID = 'suggested-legs-anchor';

export function scrollSuggestedLegsIntoView() {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(SUGGESTED_LEGS_ANCHOR_ID);
  if (el && typeof el.scrollIntoView === 'function') {
    el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    return;
  }
  try {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch {}
}
